// extracted by mini-css-extract-plugin
export default {"section":"jLPZj","option":"_uYdw","optionCheck":"ig7GF","optionText":"YSD46","empty":"prIr_","emptyIcon":"jI1wP","emptyText":"IEYjR"};